<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useChatStore } from '@/stores/chat'
import { onMounted } from 'vue'
import MerMemberFloatingBar from '@/components/MerMemberFloatingBar.vue'

const chatStore = useChatStore()

onMounted(() => {
  chatStore.connectWebSocket()
})
</script>

<template>
  <RouterView />
  <MerMemberFloatingBar />
</template>

<style scoped></style>
